import React from 'react'
import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType';
import { TimesheetSummaryReportListType } from '../../../redux/timeSheet/timeSheetType';
import { CircularAvatar } from '../../commons';
type AppProps={
    data:TimesheetSummaryReportListType[]|[];
    tableHeaders:TableHeadersType[] | [];
}
const TimeSheetSummaryReportTable = ({
    data,
    tableHeaders
}:AppProps) => {
  return (
    <>
        {data?.length > 0 &&
        data?.map((timeSheetSummaryReportData: any) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "user_name") {
                    return (
                      <td className="text-left">

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        
                        >
                          <CircularAvatar
                            name={`${timeSheetSummaryReportData?.user_name}`}
                            image={
                              timeSheetSummaryReportData?.profile_pic &&
                              timeSheetSummaryReportData?.profile_pic?.file_url
                            }
                          />
                          <div
                          >
                            <span>
                              {timeSheetSummaryReportData?.user_name}{" "}
                            </span>
                          </div>
                        </div>
                      </td>
                    );
                  } 
                  else if (header?.value == "billable_sum") {
                    return <td className={`text-left ${timeSheetSummaryReportData?.billable_sum==0?`text-danger`:""}`}>{timeSheetSummaryReportData?.billable_sum ? timeSheetSummaryReportData?.billable_sum?.toFixed(2):"00"}</td>;

                  } else if (header?.value == "non_billable_sum") {
                    return (
                      <td className={`text-left ${timeSheetSummaryReportData?.non_billable_sum==0?`text-danger`:""}`}>
                        {timeSheetSummaryReportData?.non_billable_sum?timeSheetSummaryReportData?.non_billable_sum?.toFixed(2):"00"}
                      </td>
                    );
                  } else if (header?.value == "total_hours_sum") {
                    return (
                      <td className={`text-left ${timeSheetSummaryReportData?.total_hours_sum==0?`text-danger`:""}`}>
                        {timeSheetSummaryReportData?.total_hours_sum ? timeSheetSummaryReportData?.total_hours_sum?.toFixed(2):"00"}
                      </td>
                    );
                  }

                  return null;
                })}
            </tr>
          );
        })}
    </>
  )
}

export default TimeSheetSummaryReportTable
